import { createContext } from "react";
import { type LocationType } from "@grnhse/location-control/dist/src/common/types";

export interface LocationControlSettings {
  apiKey: string;
  baseUrl: string;
  locationTypes: LocationType[];
}

export const LocationControlSettingsContext = createContext<LocationControlSettings>({
  apiKey: "",
  baseUrl: "",
  locationTypes: ["city", "state", "country"],
});
